const similarityChecker = {
    shouldPassSimilarityCheck(response) {
        return !!(response?.Approvable);
    },
};

export default similarityChecker;
